import "./style.css";
import Share from "../Share";

class SearchResults {
  static selector = ".search__results";

  constructor(block) {
    this.block = block;
    this.counter = block.querySelector(".search__results-nav-counter span");

    const shares = [...block.querySelectorAll(".share")];
    shares.map(el => new Share(el));

    this.specialismsDescriptions = block.querySelectorAll(
      ".our-specialisms__grid-item-description"
    );

    window.addEventListener("load", this.onResize);
    setTimeout(() => {
      this.onResize();
    }, 200);

    this.initCarousel();
    this.updateCarousels();

    this.backgroundImages = block.querySelectorAll(
      ".articles-and-publications-grid__item-picture"
    );
    this.setupBackgroundImages();

    this.specialismsBackgroundImages = block.querySelectorAll(
      ".our-specialisms__grid-item-image-wrapper"
    );
    this.setupSpecialismsBackgroundImages();
  }

  ellipsizeTextBox = el => {
    if (el.ellipsizeWidth && el.ellipsizeWidth === el.offsetWidth) {
      return;
    }

    if (!el.originalWords) {
      el.originalWords = el.innerText.split(" ");
    } else {
      el.innerText = el.originalWords.join(" ");
    }

    el.ellipsizeWidth = el.offsetWidth;

    const wordArray = [...el.originalWords];
    while (el.scrollHeight > el.offsetHeight) {
      wordArray.pop();
      el.innerHTML = wordArray.join(" ") + "&hellip;";
    }
  };

  setupBackgroundImages = () => {
    this.backgroundImages.forEach(backgroundImage => {
      const backgroundUrl = backgroundImage.dataset.large;
      let image = new Image();
      image.onload = () => {
        let backgroundLarge = backgroundImage.querySelector(
          ".articles-and-publications-grid__item-picture-background--large"
        );
        backgroundLarge.style.backgroundImage = "url('" + backgroundUrl + "')";
        backgroundLarge.classList.add(
          "articles-and-publications-grid__item-picture-background--large--loaded"
        );
      };
      image.src = backgroundUrl;
    });
  };

  setupSpecialismsBackgroundImages = () => {
    this.specialismsBackgroundImages.forEach(backgroundImage => {
      const backgroundUrl = backgroundImage.dataset.large;
      let image = new Image();
      image.onload = () => {
        let backgroundLarge = backgroundImage.querySelector(
          ".our-specialisms__grid-item-image--large"
        );
        backgroundLarge.style.backgroundImage = "url('" + backgroundUrl + "')";
        backgroundLarge.classList.add(
          "our-specialisms__grid-item-image--large--loaded"
        );
      };
      image.src = backgroundUrl;
    });
  };

  initCarousel() {
    this.prev = this.block.querySelector(".search__results-nav--prev");
    this.next = this.block.querySelector(".search__results-nav--next");
    this.list = this.block.querySelector(".search__results-list");
    this.items = [...Array.from(this.list.children)];
    this.currentItemIndex = 0;
    this.translateX = 0;

    if (this.items.length < 4) {
      if (this.prev) {
        this.prev.style.display = "none";
      }
      if (this.next) {
        this.next.style.display = "none";
      }
      return;
    }

    if (this.list) {
      this.list.addEventListener("mousedown", this.startDrag);
      this.list.addEventListener("touchstart", this.startDrag);
      this.list.addEventListener("touchmove", this.drag, { passive: false });
      // this.list
      //   .querySelectorAll("a")
      //   .forEach(el =>
      //     el.addEventListener("mousedown", e => e.stopPropagation())
      //   );
    }

    if (this.prev) {
      this.prev.addEventListener("click", this.goPrev);
    }
    if (this.next) {
      this.next.addEventListener("click", this.goNext);
    }

    if (this.list) {
      this.list.style.transform = "translateX(0)";
    }
  }

  cancelEvent = e => e.preventDefault();

  startDrag = e => {
    document.addEventListener("dragstart", this.cancelEvent);

    if (this.isDisabled || this.list.querySelector(".dragging")) {
      return;
    }

    const x = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    const y = (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;
    this.list.addEventListener("mousemove", this.drag);
    this.list.addEventListener("mouseup", this.endDrag);
    this.list.addEventListener("touchend", this.endDrag);
    this.dragging = false;
    this.list.style.cursor = "grabbing";
    this.mouseX = x;
    this.canDrag = true;
    if (e.type == "touchstart") {
      this.firstClientX = x;
      this.firstClientY = y;
    }
  };

  drag = e => {
    if (
      this.isDisabled ||
      this.list.querySelector(".dragging") ||
      !this.canDrag
    ) {
      return;
    }
    const x = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    const y = (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;
    if (e.type == "touchmove") {
      const minValue = 5; // threshold
      this.clientX = x - this.firstClientX;
      this.clientY = y - this.firstClientY;
      // Vertical scrolling does not work when you start swiping horizontally.
      if (Math.abs(this.clientX) > minValue && e.cancelable) {
        //do not scroll
        e.preventDefault();
      } else {
        //scroll
        return;
      }
    } else {
      //mouse - ignore
      e.preventDefault();
    }
    this.dragging = true;
    this.list.classList.add("dragging");
    this.translateX += x - this.mouseX;
    this.translateX = Math.max(Math.min(this.translateX, 0), this.minTranslate);
    this.mouseX = x;
    this.list.style.transform = `translateX(${this.translateX}px)`;
  };

  endDrag = e => {
    document.removeEventListener("dragstart", this.cancelEvent);

    if (this.isDisabled || this.list.querySelector(".dragging")) {
      return;
    }
    this.list.removeEventListener("mousemove", this.drag);
    this.list.removeEventListener("mouseup", this.endDrag);
    this.list.removeEventListener("touchend", this.endDrag);
    this.list.style.cursor = "";
    this.list.classList.remove("dragging");
    let distance = Number.POSITIVE_INFINITY;
    let selectedIndex = 0;
    this.items.forEach((item, index) => {
      const d = Math.abs(item.offsetLeft + this.translateX);
      if (d < distance) {
        distance = d;
        selectedIndex = index;
      }
    });
    this.goTo(selectedIndex);
    this.canDrag = false;
  };

  goPrev = e => {
    e.preventDefault();
    this.goTo(this.currentItemIndex - 1);
  };

  goNext = e => {
    e.preventDefault();
    this.goTo(this.currentItemIndex + 1);
  };

  goTo = index => {
    this.currentItemIndex = Math.max(0, Math.min(this.items.length - 1, index));
    if (this.prev) {
      if (this.currentItemIndex <= 0) {
        this.prev.classList.add("disabled");
      } else {
        this.prev.classList.remove("disabled");
      }
    }

    this.counter.innerText = this.currentItemIndex + 1;

    if (this.next) {
      if (this.currentItemIndex >= this.items.length - 1) {
        this.next.classList.add("disabled");
      } else {
        this.next.classList.remove("disabled");
      }
    }
    const currItem = this.items[this.currentItemIndex];
    this.translateX = -currItem.offsetLeft;
    this.list.style.transform = `translateX(${this.translateX}px)`;
  };

  updateCarousels = () => {
    if (window.innerWidth >= 1025) {
      // desktop
      this.isDisabled = true;
      this.list.style.transform = `translateX(0px)`;
    } else {
      // mobile
      this.isDisabled = false;
      this.minTranslate =
        this.items.length > 0
          ? -this.items[this.items.length - 1].offsetLeft
          : 0;
    }
  };

  onResize() {
    this.specialismsDescriptions.forEach(el => this.ellipsizeTextBox(el));
    this.updateCarousels();
  }
}

export default SearchResults;
